import {SendType} from "../../libs/enum/send-type.enum";
import {nonBlank} from "../../libs/utils/epic.utils";

export class EmailSendDto {

  public type!: SendType;
  public contactId!: string;
  public emailId!: string;
  public email!: string;
  public mediaId!: string;
  public invoiceId: string | undefined;
  public deliveryNoteId: string | undefined;
  public proformaInvoiceId: string | undefined;
  public vehicleId: string | undefined;

  constructor(init?: Partial<EmailSendDto> | undefined) {
    Object.assign(this, init);
    if (nonBlank(init?.email)) {
      this.email = init!.email!.trim().toLowerCase();
    }
  }
}
